import { useEffect } from "react";

import useThemeMode from "@/src/hooks/useThemeMode";
import { setDigitalDataThemeMode } from "@/src/utils/digitalData/themeMode";

export const useDigitalDataThemeMode = () => {
  const { resolvedMode } = useThemeMode();

  useEffect(() => {
    if (resolvedMode !== "light" && resolvedMode !== "dark") {
      return;
    }
    setDigitalDataThemeMode(resolvedMode);
  }, [resolvedMode]);
};
